import { useLocation } from "react-router";
import { RouteFactory } from "@app/routePaths";
import {
  MYSPH_CONFIG_STRING,
  MYSPH_JS_BUNDLE_PATH,
} from "@features/mySph/utils/constants";
import useIsAppWebView from "@hooks/useIsAppWebView";
import useScript from "@hooks/useScript";
import useScriptFunction from "@hooks/useScriptFunction";

/**
 * MySphLightbox component to include mySPH scripts in the document head.
 * DOC: https://sph.atlassian.net/wiki/spaces/PAPP/pages/2829778968/Quick+Start+Lightbox+Web
 */
export const useMySphLightbox = () => {
  const { pathname } = useLocation();
  const isAppWebView = useIsAppWebView();
  const excludePaths = [RouteFactory.mbo];

  useScriptFunction({
    id: "mySPHConfig",
    value: MYSPH_CONFIG_STRING,
    isDisabled: excludePaths.includes(pathname) || isAppWebView,
  });

  useScript({
    id: "mySPHBundle",
    src: MYSPH_JS_BUNDLE_PATH,
    type: "module",
    checkScriptIsLoaded: () => excludePaths.includes(pathname) || isAppWebView,
  });
};
